<template>
  <d-container fluid class="main-content-container px-4">

    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle d-block">Serviço</span>
        <h3 class="page-title">{{ service.id ? 'Editar' : 'Adicionar' }}</h3>
        <button v-if="service.id" class="btn btn-success text-white float-right" @click="newService">Novo serviço</button>
        <d-button type="button" @click.prevent="save" class="btn-accent float-right mr-2">Salvar</d-button>
      </d-col>
    </d-row>

    <!-- Content -->
    <d-row>
      <!-- Editor -->
      <d-col lg="12" class="mb-4">
        <d-card class="card-small">

          <!-- Form Example -->
          <d-card-header class="border-bottom">
            <h6 class="m-0">Dados cadastrais</h6>
          </d-card-header>

          <d-list-group flush>
            <d-list-group-item class="p-3">
              <service-form ref="serviceForm"/>
            </d-list-group-item>
          </d-list-group>
        </d-card>
      </d-col>

    </d-row>
  </d-container>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import ServiceService from '_services/rest/modules/service';
import { MODEL, _LOAD_MODEL_, _SAVE_SERVICE_SUCCESS_ } from '../components/ServiceModel';
import ServiceForm from '../components/ServiceForm.vue';

export default {
  name: 'service-page',
  components: {
    ServiceForm,
    ServiceService,
  },
  computed: {
    service() {
      const { serviceEdit } = this.$store.state.service;
      if (serviceEdit) {
        Events.$emit(_LOAD_MODEL_, serviceEdit);
        return serviceEdit;
      }
      return MODEL;
    },
  },
  methods: {
    ...mapActions([
      'setToggle',
      'getService',
    ]),
    getServiceModel() {
      this.getService(parseInt(this.$route.params.serviceId, Number));
    },
    newService() {
      this.$store.commit('setService', MODEL);
      this.$router.push({ name: 'admin-service-new' });
    },
    save() {
      this.$refs.serviceForm.save();
      Events.$on(_SAVE_SERVICE_SUCCESS_, service => {
        this.$router.push({ name: 'admin-service-edit', params: { serviceId: service.id } }).catch(() => { });
      });
    },
  },

  mounted() {
    if (this.$route.params.serviceId) {
      this.getServiceModel();
    }
  },
};
</script>

